const countries = {
  nl: {
    countryCode: "nl",
    suffix: ".nl",
    countryName: window.translations.netherlands,
    alternateLink: "nl-nl",
  },
  be: {
    countryCode: "be",
    suffix: ".be",
    countryName: window.translations.belgium,
    alternateLink: "nl-be",
    alternateLinkFr: "fr-be",
  },
  fr: {
    countryCode: "fr",
    suffix: ".fr",
    countryName: window.translations.france,
    alternateLink: "fr-fr",
  },
};

const modalButtonsWrapper = document.querySelector(".js-geo-switcher-buttons");
const modalLinksWrapper = document.querySelector(".js-geo-switcher-links");
const modalTitleWrapper = document.querySelector(".js-geo-switcher-title");
const modalIntroWrapper = document.querySelector(".js-geo-switcher-intro");

var showModal = function (countryCode) {
  console.log(countryCode);
  let countrySettings = countries[countryCode];
  if (!countrySettings) {
    countrySettings = countries["be"];
  }
  var hostname = window.location.hostname;
  var hostDomain = hostname.replace(/^.*\./, "");
  var geoCountrySelected = localStorage.getItem("geoCountrySelected");

  // Create buttons for each country
  createButtons(countryCode, hostDomain);
  createLinks(countryCode, hostDomain);

  if (modalLinksWrapper.innerHTML.length == 0) {
    console.log("empty");
    document.querySelector(".geo-switcher-links").classList.add("vh");
  }

  // check if same domain as current location
  if (hostDomain === countryCode) {
    console.log("on same site");
    return false;
  } else {
    if (geoCountrySelected && geoCountrySelected !== "") {
      return false;
    } else {
      var $modal = $("#geo-switcher-modal");
      $modal.addClass("modal--active");
      $modal.find(".js-modal-close").click(function (e) {
        $modal.removeClass("modal--active");
      });
    }
  }
};

var createLinks = function (countryCode, hostDomain) {
  var alternateLinks = document.querySelectorAll(
    `link[rel="alternate"][href*="${window.location.hostname}"]`
  );

  alternateLinks.forEach((alternateLink) => {
    const hreflang = alternateLink.getAttribute("hreflang");

    if (
      hreflang &&
      hreflang !== "x-default" &&
      !hreflang.includes(document.documentElement.lang)
    ) {
      const href = alternateLink.getAttribute("href");

      const language = hreflang.replace(hostDomain, "").replace("-", "");

      modalLinksWrapper.innerHTML += `
        <a href="${href}" class="text-link"> ${
        window.translations[`link_${language}`]
      }</a>
      `;
    }
  });
};

var createButtons = function (countryCode, hostDomain) {
  var allCountries = countries;
  var currentCountryObject = countries[countryCode];
  var hostObject = countries[hostDomain];

  if (!currentCountryObject) {
    currentCountryObject = countries["be"];
  }

  // Add current country button
  if (hostObject) {
    modalButtonsWrapper.innerHTML = `
      <button class="btn btn--secondary js-modal-close js-other-country-selected">${hostObject.countryName}</button>
    `;
  }

  // Add other country buttons
  Object.keys(allCountries).forEach((key) => {
    var country = allCountries[key];
    var countryCode = country.countryCode;
    var countryName = country.countryName;
    var alternateLinkFromCountryEl = document.querySelector(`[hreflang="${country.alternateLink}"]`);

    // Redirect to French alternate link (eg .be/fr) on .fr domain
    if (hostDomain === 'fr' && country.alternateLinkFr) {
      alternateLinkFromCountryEl = document.querySelector(`[hreflang="${country.alternateLinkFr}"]`);
    }

    if (countryCode !== hostDomain) {
      var alternateLinkHref = alternateLinkFromCountryEl.getAttribute('href');

      modalButtonsWrapper.innerHTML += `
        <a href="${alternateLinkHref}" class="btn btn--secondary js-exclude-blank-link">${countryName}</a>
      `;
    }
  });

  var hostSelected = document.querySelector(".js-other-country-selected");
  hostSelected.addEventListener("click", function () {
    localStorage.setItem("geoCountrySelected", hostObject.countryCode);
  });
};

var isBot = /bot|googlebot|crawler|spider|robot|crawling/i.test(
  navigator.userAgent
);
// check localstorage
var geoCountry = localStorage.getItem("geoCountry2");
// don't redirect when userAgent is a bot
if (!isBot) {
  if (geoCountry && geoCountry !== "") {
    // redirectByGeoCountry(geoCountry);
    showModal(geoCountry);
  } else {
    // get geo data
    jQuery.ajax({
      url: "https://geoip.apps.esign.eu/api/v1/location",
      type: "GET",
      dataType: "json",
      headers: {
        Authorization:
          "Bearer vENRyzI8Qh4mFpP57Bk4G6W7RCmzfxH5usYwutHYlU1BDuiVLZQR9DBmeEidUmGgKLkAyomANIww1QBh",
        Accept: "application/json",
      },
      success: function (response) {
        if (response && response.iso_code) {
          var code = response.iso_code.toLowerCase();
          localStorage.setItem("geoCountry2", code);
          // redirectByGeoCountry(code);
          showModal(code);
        }
      },
    });
  }
}
